export default __webpack_public_path__ + "static/media/Location.aa650ea9.svg";